import React, { useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './styles'
import translator from '../../translate'
import { useDispatch, useSelector } from 'react-redux'
import { registerMarketingInfo, addToMainSubscriptionGroup } from '../../api/sign-up'
import moment from 'moment-timezone'
import {
  CssBaseline,
  Grid,
  Box,
  Typography,
  Radio,
  Card,
  CircularProgress,
} from '@material-ui/core'
import { track, init } from '@amplitude/analytics-browser'

import { get as getCookie } from 'es-cookie'
import { set as setCookie } from 'es-cookie'
import { userGetSelfAction } from 'src/reducers/user/action'
import { CoreButton, CoreTextField } from 'src/components/core'
import { INTEREST } from './interests'
const RadioButton = withStyles({
  root: {
    '&$checked': {
      color: '#015FFB',
    },
  },
  checked: {},
})(props => <Radio color="default" {...props} />)

function PurposeSelectionField(props) {
  const {
    classes,
    mode,
    onContinue,
    onBack,
    onSelectInterest,
    selectedInterest,
    selectedIndex,
  } = props
  const [loading, setLoading] = React.useState(false)
  const [purpose, setPurpose] = React.useState('')
  const dispatch = useDispatch()
  const primaryInterests = useSelector(
    state => state.marketing.primaryInterests,
  )

  useEffect(() => {
    dispatch(userGetSelfAction())

    if (getCookie('email')) {
      init(process.env.REACT_APP_AMPLITUDE_KEY, getCookie('email'), {
        serverUrl: `${process.env.REACT_APP_URL}Analytics/Track`,
      })
    }

    // Hide Intercom launcher on purpose page
    if (window.Intercom) {
      window.Intercom('update', {
        hide_default_launcher: true,
      })
    }
  }, [dispatch])

  const handleContinue = async event => {
    setLoading(true)

    const selectedIndexofText = selectedIndex
    let timeZone = 'None'

    if (moment.tz.guess() != undefined) {
      timeZone = moment.tz.guess()
    }
    const data = {
      selectedIndexofText,
      purpose,
      timeZone,
    }

    track('onboarding_complete_event', {
      purpose_text: purpose,
      interest: selectedInterest,
      delivery_method: '',
    })

    let response = await registerMarketingInfo(data)
    if (response.statusCode == 200) {
      window.Intercom('update', {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'a1mmx6vo',
        purpose_text: purpose,
        purpose_selection: selectedInterest,
        hide_default_launcher: true,
      })
      await new Promise(resolve => setTimeout(resolve, 1000))

      if (
        getCookie('redirectUrl') != '' &&
        getCookie('redirectUrl') != null &&
        getCookie('redirectUrl') != undefined
      ) {
        window.location.href = getCookie('redirectUrl')
        setCookie('redirectUrl', '')
      } else {
        window.location.href = '/'
      }
    }
  }

  if (mode === 'interest') {
    return (
      <div className={classes.purposePageRoot}>
        <CssBaseline />
        <Box className={classes.purposeLogo}>
          <Box
            component="img"
            src="/assets/mcg-icon.svg"
            style={{ width: 32, height: 32 }}
          />
          <Box
            component="img"
            src="/assets/mcg-text.svg"
            style={{ width: '130px', height: 32 }}
          />
        </Box>
        <div className={classes.purposeCenterContainer}>
          <div className={classes.purposeInterestWrapper}>
            <Typography className={classes.purposeSubtitle}>
              {`LET'S PERSONALIZE YOUR ONBOARDING.`}
            </Typography>
            <Box mt={2} />
            <Typography className={classes.purposeHeading}>
              Which best describes your primary role?
            </Typography>
            <Box mt={3} />
            <div className={classes.purposeOptionsContainer}>
              {primaryInterests.map((option, index) => (
                <Card
                  className={classes.purposeOptionCard}
                  style={{
                    borderColor:
                      selectedInterest === option.interest
                        ? '#015FFB'
                        : '#CBD0D7',
                    backgroundColor: '#ffffff',
                  }}
                  onClick={() => onSelectInterest(option.interest, option.id)}
                  key={'option_' + index}
                >
                  <div className={classes.purposeOptionInner}>
                    <RadioButton
                      checked={selectedInterest === option.interest}
                      value={option.interest}
                    />
                    <Typography
                      className={classes.purposeOptionText}
                      style={{
                        color:
                          selectedInterest === option.interest
                            ? '#015FFB'
                            : '#1D1D1F',
                      }}
                    >
                      {option.interest}
                    </Typography>
                  </div>
                </Card>
              ))}
            </div>
            <Box mt={3} />
            <CoreButton
              onClick={selectedInterest ? onContinue : undefined}
              variant="contained"
              size="large"
              fullWidth
              style={{
                backgroundColor: selectedInterest ? undefined : '#919EAB',
                borderRadius: '10px',
                height: '40px',
                color: '#fff',
                cursor: selectedInterest ? 'pointer' : 'default',
              }}
            >
              {translator._('signUp.continue')}
            </CoreButton>
            <Typography
              onClick={() => {
                if (onSelectInterest) onSelectInterest('', 0)
                // No interest picked → make sure the user still lands in MailerLite's
                // main group (issue #478). Fire-and-forget; don't block the flow.
                addToMainSubscriptionGroup().catch(() => {})
                onContinue()
              }}
              className={classes.purposeSkipButton}
            >
              Skip
            </Typography>
          </div>
        </div>
      </div>
    )
  }

  // mode === 'purpose'
  const isCreator = selectedInterest === INTEREST.CREATOR
  const purposeHeading = isCreator
    ? 'How do you create courses now? Why are you looking for a change?'
    : 'What is the main goal that you want to achieve?'
  const purposePlaceholder = isCreator
    ? 'e.g., I use PowerPoint, but it lacks interactivity...'
    : 'Briefly tell us what you are looking to build so we can guide you better.'

  return (
    <div className={classes.purposePageRoot}>
      <CssBaseline />
      <Box className={classes.purposeLogo}>
        <Box
          component="img"
          src="/assets/mcg-icon.svg"
          style={{ width: 32, height: 32 }}
        />
        <Box
          component="img"
          src="/assets/mcg-text.svg"
          style={{ width: '130px', height: 32 }}
        />
      </Box>
      <div className={classes.purposeCenterContainer}>
        <div className={classes.purposeInterestWrapper}>
          {onBack && (
            <Typography onClick={onBack} className={classes.deliveryBackButton}>
              ‹&nbsp;&nbsp;Back
            </Typography>
          )}
          {isCreator && (
            <>
              <Box mt={3} />
              <Typography className={classes.purposeSubtitle}>
                CREATOR / SOLOPRENEUR
              </Typography>
              <Box mt={2} />
            </>
          )}
          {!isCreator && <Box mt={2} />}
          <Typography className={classes.purposeHeading}>
            {purposeHeading}
          </Typography>
          <Box m={1}></Box>
          <CoreTextField
            fullWidth
            multiline
            placeholder={purposePlaceholder}
            rows={10}
            onChange={e => {
              setPurpose(e.target.value)
            }}
          ></CoreTextField>
          <Box mt={3} />
          {loading && (
            <div className={classes.circularProgress}>
              <CircularProgress />
            </div>
          )}
          {!loading && (
            <CoreButton
              onClick={() => {
                if (onContinue) {
                  onContinue(purpose)
                } else {
                  handleContinue()
                }
              }}
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              style={{
                borderRadius: '10px',
                height: '40px',
              }}
            >
              Continue
            </CoreButton>
          )}
          {isCreator && (
            <Typography
              onClick={() => onContinue && onContinue('')}
              className={classes.purposeSkipButton}
            >
              Skip
            </Typography>
          )}
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(PurposeSelectionField)
